import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 0 20px;
    }
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    padding: 35px 0 50px;
    display: flex;
    flex-direction: column;
    gap: 30px;
`
export const List = styled.ul`
    display: flex;
    gap: 30px;
    padding-top: 20px;
    position: relative;
    &::before{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        top: 0;
        right: 50%;
        transform: translateX(50%);
    }
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
        align-items: center;
    }
`
export const ListItem = styled.li`
    width: calc((100% - 90px) / 4);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
    }
`
export const ItemImg = styled.img`
    width: 64px;
    height: 64px;
    margin: 32px;
    box-sizing: border-box;
`
export const ItemTitle = styled.h3`
    font-size: 14px;
    color: #333333;
    text-transform: uppercase;
    padding: 25px 0 15px;
    text-align: center;
`
export const ItemText = styled.p`
    font-size: 17px;
    color: #999;
    line-height: 1.66em;
    text-align: center;
`
